import React from "react";
import PropTypes from "prop-types";
import styled, { ThemeProvider, css } from "styled-components";
import { darken } from "polished";
import theme from "@design-system/theme";

const Button = styled.button`
  border-radius: 20px;
  border-width: 2px;
  padding: 8px 15px;
  border: 2px solid transparent;
  line-height: 1.428;
  border-style: none;
  cursor: pointer;
  font-family: "Gotham-Medium";
  font-size: 12px;

  &:hover {
      ${props =>
        props.shadow &&
        css`
          box-shadow: 0 5px 14px -9px;
          transform: translateY(-2px);
          transition: ease all 0.2s;
        `}
  }

  ${props =>
    !props.variant &&
    css`
      background-color: ${props.theme.primary};
      border: 2px solid ${props.theme.primary};
      &:hover {
        background-color: ${darken(0.01, props.theme.primary)};
      }
    `}

  ${props =>
    props.variant === "secondary" &&
    css`
      background-color: ${props.theme.borderGray};
      border: 2px solid ${props.theme.borderGray};

      &:hover {
        background-color: ${darken(0.05, props.theme.borderGray)};
      }
    `}

    ${props =>
      props.variant === "danger" &&
      css`
        background-color: ${props.theme.red};
        border: 2px solid ${props.theme.red};
        color: ghostwhite
        &:hover {
          background-color: ${darken(0.05, props.theme.red)};
        }
      `}

    ${props =>
      props.variant === "bordered-dark" &&
      css`
        background-color: transparent;
        border: 2px solid ${props.theme.borderGraySecondary};

        &:hover {
          border: 2px solid ${darken(0.05, props.theme.borderGray)};
        }
      `}

    ${props =>
      props.variant === "bordered-light" &&
      css`
        background-color: transparent;
        border: 2px solid ${props.theme.borderGraySecondary};
        color: white;

        &:hover {
          border: 2px solid white;
        }
      `}

    ${props =>
      props.variant === "no-borders" &&
      css`
        background-color: transparent;
        border: 2px solid transparent;

        &:hover {
          background-color: rgba(0, 0, 0, 0.03);
        }
      `}

      ${props =>
        props.disabled &&
        css`
          cursor: not-allowed;
          border: 2px solid rgba(0, 0, 0, 0.03);
          background-color: rgba(0, 0, 0, 0.03);

          &:hover {
            background-color: rgba(0, 0, 0, 0.03);
          }
        `}
`;
Button.displayName = "Button";

const StyledButton = ({ children, ...other }) => (
  <ThemeProvider theme={theme}>
    <Button {...other}>{children}</Button>
  </ThemeProvider>
);

StyledButton.propTypes = {
  variant: PropTypes.oneOf([
    "null",
    "secondary",
    "danger",
    "bordered-dark",
    "bordered-light",
    "no-borders"
  ]),
  shadow: PropTypes.bool
};
export default StyledButton;
